import axios from "axios";

const URL = "https://4r11nuyxa8.execute-api.us-east-1.amazonaws.com/test/";


export const sendWaiter = (
  message,
  zont,
  endpoint,
  chat_id,
  showModal,
  messageGot,
  onSuccess,
  onError
) => {
  return new Promise((resolve, reject) => {
    const data = {
      chat_id: `${chat_id}`,
      table: zont,
      message: message,
    };
    axios
      .post(`${URL}${endpoint}`, data)
      .then((response) => {
        console.log(
          `!!!!!Table ${data.table} called the waiter !!!!`,
          response.data
        );
        showModal(messageGot, false, true);
        // Call the success callback function if provided
        onSuccess();
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error sending Call Waiter:", error);
        // Call the error callback function if provided
        if (typeof onError === "function") {
          onError();
        }
        reject(error);
      });
  });
};
export const sendBill = (
  message,
  zont,
  endpoint,
  chat_id,
  onSuccess,
  onError
) => {
  return new Promise((resolve, reject) => {
    const data = {
      chat_id: `${chat_id}`,
      table: zont,
      message: message,
    };

    axios
      .post(`${URL}${endpoint}`, data)
      .then(function (response) {
        // Call the success callback function if provided
        if (typeof onSuccess === "function") {
          onSuccess();
        }
        resolve(response.data);
      })
      .catch(function (error) {
        console.error("Error sending Bill:", error);
        if (typeof onError === "function") {
          onError();
        }
        reject(error);
      });
  });
};

export const sendTech = (chat_id, message) => {
  // return new Promise((resolve, reject) => {
  console.log("from BotRequest");
  const data = {
    chat_id: `${chat_id}` || -1002144756413,
    message: message,
  };
  axios
    .post( `${ URL }/button-booking`, data )
    .then(function (response) {
      console.log("Test Message sent to Telegram bot:", response.data);
      // resolve(response.data);
    })
    .catch(function (error) {
      console.error("Error sending sendTech:", error);
      // reject(error);
    });
  // });
};

export const sendTest = () => {
  axios
    .get("https://button.hopto.org/t")
    .then(function (response) {
      console.log("Test Message sent to Telegram bot:", response.data);
    })
    .catch(function (error) {
      console.error("Error sending test:", error);
    });
};
